"use strict";

/**
 * This function is to be able to accept /#/your_route URLs as well as html5 history URLs
 * like /your_route.  It simple takes out the '/#' and pushes that to html5 state.
 * @param browserHistory
 */
module.exports.HandleHashBangUrls = function (browserHistory) {
    if (browserHistory && browserHistory.listen && typeof browserHistory.listen == "function") {

        //hook to the history and listen for anything with a hashbanger
        browserHistory.listen(function (location) {
            if (location.pathname == "/" && location.hash && location.hash.match(/^#\//)) {
                //take the hash banger out, and push to html5 history of equivalent
                browserHistory.push({ pathname: location.hash.replace(/#/, "") });
            }
        });
    } else {
        //todo: log this with a logger, not console
        console.warn("It seems you have not passed in a browserHistory created from react-router or history package!");
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/ReactRouterHelper.js
// module id = 862
// module chunks = 0